import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, FormArray, FormGroupName } from '@angular/forms';

@Component({
  selector: 'app-test-rates',
  templateUrl: './test-rates.component.html',
  styleUrls: ['./test-rates.component.scss']
})
export class TestRatesComponent {
  rates_grabbed = false;
  carrier_rate_error: boolean | null = null;
  customer_rate_error: boolean | null = null;

  my_form = this.fb.group({
    rate_method: [1],
    origin_type: [''],
    destination_type: [''],
    origin_city: [''],
    origin_state: [''],
    origin_postal: [''],
    destination_city: [''],
    destination_state: [''],
    destination_postal: ['']
  })

  package_form = this.fb.group({
    width: [''],
    height: [''],
    length: [''],
    weight: [''],
    stack_height: [0]
  })

  shipment_form: FormGroup;

  carrier_rate = {
    rate: '0',
    weight: 0,
    weight_start: 0,
    weight_end: 0,
    transit_time: 0,
    min_rate: '0'
  }
  customer_rate = {
    rate: '0',
    weight: 0,
    weight_start: 0,
    weight_end: 0,
    min_rate: '0'
  }

  /*Lists of options*/
  rate_methods = [
    'Weight',
    'Length'
  ]

  location_types = [
    'CITY_STATE',
    'POSTAL_CODE'
  ]

  createPackageFormGroup(): FormGroup {
    return this.fb.group({
      width: [''],
      height: [''],
      length: [''],
      weight: [''],
      stack_height: [0]
    })
  }

  addPackage(){
    this.packages.push(this.createPackageFormGroup());
  }

  removePackage(index: number){
    this.packages.removeAt(index);
  }

  get packages(): FormArray {
    return this.shipment_form.get('packages') as FormArray;
  }

  search(){
    let origin_location = this.my_form.get('origin_type')?.value === 'CITY_STATE' ? this.my_form.get('origin_city')?.value + ', ' + this.my_form.get('origin_state')?.value : this.my_form.get('origin_postal')?.value;
    let destination_location = this.my_form.get('destination_type')?.value === 'CITY_STATE' ? this.my_form.get('destination_city')?.value + ', ' + this.my_form.get('destination_state')?.value : this.my_form.get('destination_postal')?.value;
    
    let packages_list = [];
    for(let i = 0; i < this.packages.length; i++){
      const packageFormGroup: FormGroup = this.packages.at(i) as FormGroup
      let new_package = {
        width: packageFormGroup.get('width')?.value,
        length: packageFormGroup.get('length')?.value,
        weight: packageFormGroup.get('weight')?.value,
        height: packageFormGroup.get('height')?.value,
        stacck_height: packageFormGroup.get('stack_height')?.value
      }
      packages_list.push(new_package);
    }

    let postData = {
      rate_method: this.my_form.get('rate_method')?.value,
      zone_data: true,
      carrier_contact_uuid: "4354d4bc-7a69-4d7b-b29b-16e62a56f2ee",
      customer_contact_uuid: "b0c472a0-e85a-439a-9dbc-2ae40304a9f5",
      locations: {
        origin: {
          type: this.my_form.get('origin_type')?.value,
          value: origin_location
        },
        destination: {
          type: this.my_form.get('destination_type')?.value,
          value: destination_location
        }
      },
      shipment: {
        packages: packages_list
      }
    }

    console.log(postData);
    this.http.post<any>(`/api/test_rates/test_rates.php`, postData).subscribe(
      (response)=> {
        // Carrier Rates
        if(response.carrier_rate.total_rate){
          this.carrier_rate.rate = response.carrier_rate.total_rate;
        }
        if(response.carrier_rate.total_weight){
          this.carrier_rate.weight = response.carrier_rate.total_weight;
        }
        if(response.carrier_rate.weight_start){
          this.carrier_rate.weight_start = response.carrier_rate.weight_start;
        }
        if(response.carrier_rate.weight_end){
          this.carrier_rate.weight_end = response.carrier_rate.weight_end;
        }
        if(response.carrier_rate.transit_time){
          this.carrier_rate.transit_time = response.carrier_rate.transit_time;
        }
        if(response.carrier_rate.min_rate){
          this.carrier_rate.min_rate = response.carrier_rate.min_rate;
        }

        // Customer Rates
        if(response.customer_rate.total_rate){
          this.customer_rate.rate = response.customer_rate.total_rate;
        }
        if(response.customer_rate.total_weight){
          this.customer_rate.weight = response.customer_rate.total_weight;
        }
        if(response.customer_rate.weight_start){
          this.customer_rate.weight_start = response.customer_rate.weight_start;
        }
        if(response.customer_rate.weight_end){
          this.customer_rate.weight_end = response.customer_rate.weight_end;
        }
        if(response.customer_rate.min_rate){
          this.customer_rate.min_rate = response.customer_rate.min_rate;
        }
        console.log(response)

        this.rates_grabbed = true;
        this.carrier_rate_error = false;
      },
      (error) => {
        console.error(error);
        this.carrier_rate_error = false;
        this.rates_grabbed = true;
        console.log(this.carrier_rate_error)
      }
    )
  }

  validate(postData: any){
    // Check that the measurement inputs are numbers
    if(isNaN(postData.weight)){
      console.log('Weight is not an numberS')
    }
  }

  constructor(private http: HttpClient, private fb: FormBuilder){
    this.shipment_form = this.fb.group({
      packages: this.fb.array([this.createPackageFormGroup()])
    })
  }
}
